// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#dialog {\n  border: 1px solid #4E4E4E;\n  background-color: #171921;\n  color: white;\n}\n#dialog_title {\n  justify-content: center;\n  font-weight: 600;\n  border-bottom: 1px solid #3C3E45;\n  color: white;\n  height: 40px;\n  line-height: 40px;\n}\n#dialog_body {\n  padding-top: 20px;\n  padding-bottom: 5px;\n  color: white;\n}\n#dialog_exit {\n  position: absolute;\n  right: 10px;\n}\n#btn_img {\n  vertical-align: middle;\n  height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
